
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/website-development",
      function () {
        return require("private-next-pages/website-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/website-development"])
      });
    }
  